<template>
  <v-container id="login" class="fill-height justify-center" tag="section">
    <v-row justify="center">
      <v-slide-y-transition appear>
        <base-material-card color="success" light max-width="100%" width="400" class="px-5 py-3">
          <template v-slot:heading>
            <div class="text-center">
              <h1 v-if="!passwordReset" class="display-2 font-weight-bold mb-2">Login</h1>
              <h1 v-if="passwordReset" class="display-2 font-weight-bold mb-2">
                Reiniciar Contraseña
              </h1>
            </div>
          </template>

          <v-overlay :value="overlay">
            <v-progress-circular :size="50" color="green" indeterminate></v-progress-circular>
          </v-overlay>

          <!-- Inicia formulario de login -->
          <!-- Campo correo electronico formulario login -->
          <v-card-text class="text-center">
            <v-text-field
              color="secondary"
              label="Correo electrónico..."
              prepend-icon="mdi-email-outline"
              v-model="$v.email.$model"
              :error-messages="emailErrors"
              required
              @input="$v.email.$reset()"
              @blur="$v.email.$touch()"
            />

            <!-- campo contraseña formulario login -->
            <v-text-field
              v-if="!passwordReset"
              class="mb-8"
              color="secondary"
              label="Contraseña..."
              prepend-icon="mdi-lock-outline"
              v-model="$v.password.$model"
              :append-icon="showPassword ? 'mdi-eye-off' : 'mdi-eye'"
              :type="showPassword ? 'text' : 'password'"
              :error-messages="passwordErrors"
              required
              @input="$v.password.$reset()"
              @blur="$v.password.$touch()"
              :counter="15"
              @click:append="showPassword = !showPassword"
            />
            <!-- Botones de formulario login -->
            <!-- Boton para reinicio de contraseña -->
            <v-btn
              v-if="!passwordReset"
              x-small
              color
              depressed
              class="v-btn--text red--text"
              @click.stop=";(passwordReset = true), (email = '')"
              >¿Olvidaste tu contraseña?</v-btn
            >

            <!-- Boton para iniciar sesion -->
            <pages-btn
              v-if="!passwordReset"
              large
              color
              depressed
              class="v-btn--text success--text"
              @click="login"
              :disabled="$v.$invalid"
              >Iniciar Sesión</pages-btn
            >

            <!-- Botones de formulario reinicio de contraseña -->
            <!-- Cancelar el reinicio de contraseña -->
            <v-btn
              v-if="passwordReset"
              color="red darken-1"
              text
              @click=";(passwordReset = false), (email = '')"
              >Cancelar</v-btn
            >
            <!-- Aceptar el reinicio de contraseña -->
            <v-btn
              v-if="passwordReset"
              color="blue darken-1"
              text
              @click="resetPassword"
              :disabled="$v.email.$invalid"
              >Aceptar</v-btn
            >
          </v-card-text>
          <v-snackbar v-model="snackbar" color="red darken-4" right top :timeout="timeout">
            {{ errorMessage }}
            <!-- <v-btn x-small @click="snackbar = false">
              Cerrar
            </v-btn>-->
          </v-snackbar>
        </base-material-card>
      </v-slide-y-transition>
    </v-row>
  </v-container>
</template>

<script>
import { validationMixin } from 'vuelidate'
import { required, minLength, maxLength, email } from 'vuelidate/lib/validators'

// import socket from '@/socket'

const oneNumber = (value) => /[0-9]/.test(value)
const oneUpperCase = (value) => /[A-Z]/.test(value)
const oneLowerCase = (value) => /[a-z]/.test(value)

export default {
  name: 'PagesLogin',
  mixins: [validationMixin],

  validations: {
    email: { required, email },
    password: {
      required,
      minLength: minLength(6),
      maxLength: maxLength(15),
      oneNumber,
      oneUpperCase,
      oneLowerCase,
    },
  },

  components: {
    PagesBtn: () => import('./components/Btn'),
  },

  data: () => ({
    overlay: false,
    email: process.env.VUE_APP_USER,
    password: process.env.VUE_APP_PASSWORD,
    errorMessage: null,
    snackbar: false,
    timeout: 2000,
    showPassword: false,
    passwordReset: false,
  }),
  /* created() {
    socket.on('connect_error', (err) => {
      if (err.message === 'invalid username') {
        console.log('error created scoket')
      }
    })
  },
  destroyed() {
    socket.off('connect_error')
  }, */
  computed: {
    emailErrors() {
      const errors = []
      if (!this.$v.email.$dirty) return errors
      !this.$v.email.email && errors.push('Debe ser un correo electrónico válido')
      !this.$v.email.required && errors.push('El correo electrónico es requerido')
      return errors
    },
    passwordErrors() {
      const errors = []
      if (!this.$v.password.$dirty) return errors
      !this.$v.password.minLength &&
        errors.push('La contraseña debe de tener un mínimo de 6 caracteres.')
      !this.$v.password.maxLength &&
        errors.push('La contraseña debe de tener un máximo de 15 caracteres.')
      !this.$v.password.required && errors.push('La contraseña es requerida.')
      !this.$v.password.oneNumber && errors.push('La contraseña debe de tener al menos un número')
      !this.$v.password.oneUpperCase &&
        errors.push('La contraseña debe de tener al menos una letra mayúscula')
      !this.$v.password.oneLowerCase &&
        errors.push('La contraseña debe de tener al menos una letra minúscula')
      return errors
    },
  },
  methods: {
    login() {
      this.$v.$touch()
      if (!this.$v.$invalid) {
        this.overlay = true
        this.$store
          .dispatch('auth/login', {
            correo: this.email,
            password: this.password,
          })
          .then(() => {
            // console.info(`Usar socket: ${process.env.VUE_APP_USE_SOCKET}`)
            // if (process.env.VUE_APP_USE_SOCKET === true) {
            //   console.info(`Entra a conectarse al socket`)
            //   let username = this.email
            //   this.$socket.auth = { username }
            //   this.$socket.connect()
            // }
            this.overlay = false
            this.clear()
            this.$store.state.menu = 'dashboard'
            this.$router.push('/')
          })
          .catch((err) => {
            console.log(err)
            this.overlay = false
            this.errorMessage = err.response.data.msg
            this.snackbar = true
          })
      }
    },

    resetPassword() {
      this.$v.$touch()
      if (!this.$v.email.$invalid) {
        this.$store
          .dispatch('auth/resetPassword', { correo: this.email })
          .then(() => {
            this.$store.commit('ALERT', {
              color: 'success',
              text: 'Se ha enviado un correo electrónico con tu nueva contraseña',
            })
          })
          .catch((err) => {
            this.$store.commit('ALERT', {
              color: 'error',
              text: err.response.data.msg,
            })
          })
      }
      this.clear()
    },

    clear() {
      this.$v.$reset()
      this.email = ''
      this.password = ''
      this.passwordReset = false
    },
  },
}
</script>
